import React, { useEffect, useState } from 'react';

import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { cilX, cilTask } from '@coreui/icons';
import CIcon from '@coreui/icons-react'

const ContactUsModal = (prop) => {
  const { header, isOpen, toggle} = prop;

 
  return (
    <Modal isOpen={isOpen} toggle={toggle} className="custom-modal">
      <ModalHeader>
        {header}
        <a href="#" className="close-icon" onClick={toggle} aria-label="Close">
        
          <CIcon className="closeIconSet"  icon={cilX} size="xl"></CIcon>
        </a>
      </ModalHeader>
      <ModalBody className="paddingAllSide">
        <div>
          <p className="TROUSParagraph pt-2">
            <strong className="TROUSStrong">
              Call us from the 4DSPS app
            </strong>
            <br />
            Contacting 4DSPS is now easier than ever when you contact us from the 4DSPS app on your Android or iOS phone or tablet! Calling through the app is free - all you need is an internet or cellular connection.
          </p>
          <div style={{ paddingTop: '5%' }}>
            <strong className="TROUSStrong">
              Download 4DSPS Mobile App
            </strong>
            <div className="PlayStoreDiv">
              {/* Add your app download links or images here */}
            </div>
          </div>
          <div>
            <strong className="TROUSStrong">
              Reach Us : &nbsp;
              <label className="TROUSParagraph">
                <a className="whitecolor" href="https://4dimensionsllc.awsapps.com/auth/?client_id=6b9615ec01be1c8d&redirect_uri=https%3A%2F%2Fwebmail.mail.us-east-1.awsapps.com%2Fworkmail%2F">info@4dsps.com</a>
              </label>
            </strong>
          </div>
          <div className="row">
            <div className="col-lg-6 col-md-6">
              <strong className="TROUSStrong">
                Address : &nbsp;
                <label className="TROUSParagraph">402 Rolling Green Ave, New Castle DE 19720
                </label>
              </strong>
            </div>
            {/*<div className="col-lg-6 col-md-6">*/}
            {/*  <strong className="TROUSStrong">*/}
            {/*    Address : 216 A ,<label className="TROUSParagraph"> Al-Rehmat Project, Peco Road, Lahore, PK</label>*/}
            {/*  </strong>*/}
            {/*</div>*/}
          </div>
          <div>
            <strong className="TROUSStrong">
              <a className="whitecolor" href="https://4dsps.com/">
                <u className="whitecolor">info@4dsps.com</u>
              </a>,&nbsp;
              Contact:&nbsp;&nbsp;
              <i style={{ fontSize: '18px' }} className="fa">&#x260E;</i>
              <label className="TROUSParagraph">UAN: +1 855 789 4DIM</label>
            </strong>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};
export default ContactUsModal;
